export default "__VITE_ASSET__BUekSgjb__"